import { pagesPath } from "@/utils/pages-path";

export const membersZendeskSsoLink = (returnTo?: string) => {
  return pagesPath.members.zendesk.sso.$url({ query: { return_to: returnTo } })
    .path;
};
export const employersZendeskSsoLink = (returnTo?: string) => {
  return pagesPath.employers.zendesk.sso.$url({
    query: { return_to: returnTo },
  }).path;
};
